export default __webpack_public_path__ + "static/media/img-escort-banner.64fd0361.png";